if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.lastTouchEnd = 0;
        this.preventGestureZoom = this.preventGestureZoom.bind(this);
        this.preventPinchZoom = this.preventPinchZoom.bind(this);
        this.preventDoubleTapZoom = this.preventDoubleTapZoom.bind(this);
      }

      hide() {
        this.removeZoomPrevention();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.addZoomPrevention();
      }

      // Disable double-tap / pinch-zoom on touch devices while the lightbox is open.
      // `touch-action: pan-x pan-y` in CSS covers most browsers; the gesture/touch
      // listeners below cover iOS Safari, which handles pinch at the page level.
      addZoomPrevention() {
        this.addEventListener('gesturestart', this.preventGestureZoom, { passive: false });
        this.addEventListener('gesturechange', this.preventGestureZoom, { passive: false });
        this.addEventListener('touchmove', this.preventPinchZoom, { passive: false });
        this.addEventListener('touchend', this.preventDoubleTapZoom, { passive: false });
      }

      removeZoomPrevention() {
        this.removeEventListener('gesturestart', this.preventGestureZoom);
        this.removeEventListener('gesturechange', this.preventGestureZoom);
        this.removeEventListener('touchmove', this.preventPinchZoom);
        this.removeEventListener('touchend', this.preventDoubleTapZoom);
        this.lastTouchEnd = 0;
      }

      preventGestureZoom(event) {
        event.preventDefault();
      }

      preventPinchZoom(event) {
        if ((event.scale !== undefined && event.scale !== 1) || event.touches.length > 1) {
          event.preventDefault();
        }
      }

      preventDoubleTapZoom(event) {
        const now = Date.now();
        // Ignore the close button so rapid taps there still register as clicks
        if (now - this.lastTouchEnd <= 300 && !event.target.closest('.product-media-modal__toggle')) {
          event.preventDefault();
        }
        this.lastTouchEnd = now;
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}